import {Component, inject, ViewChild, AfterViewInit, DestroyRef, ChangeDetectionStrategy} from "@angular/core"
import {Router, ActivatedRoute, RouterOutlet, NavigationEnd, NavigationSkipped} from "@angular/router"
import {filter} from "rxjs/operators"
import {TableLayoutComponent} from "@platform/components/layouts/table-layout/table-layout.component"
import {TaskTypesTableComponent} from "@platform/components/task-types/task-types-table/task-types-table.component"
import {takeUntilDestroyed} from "@angular/core/rxjs-interop"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-task-types-page",
    imports: [RouterOutlet, TaskTypesTableComponent, TableLayoutComponent],
    template: `
        <cm-table-layout>
            <cm-task-types-table></cm-task-types-table>
        </cm-table-layout>
        <router-outlet></router-outlet>
    `,
    styleUrls: [],
})
export class TaskTypesPageComponent implements AfterViewInit {
    private readonly router = inject(Router)
    private readonly route = inject(ActivatedRoute)
    private readonly destroyRef = inject(DestroyRef)
    @ViewChild(TaskTypesTableComponent) taskTypesTable?: TaskTypesTableComponent

    ngAfterViewInit() {
        // Check initial route state
        this.checkAndHandleRoute()

        // Listen for navigation events to handle create dialog opening/closing
        // We need to handle both NavigationEnd and NavigationSkipped because when
        // two navigations happen simultaneously, the first gets cancelled and
        // the second gets skipped, but the URL still changes.
        this.router.events
            .pipe(
                filter((event): event is NavigationEnd | NavigationSkipped => event instanceof NavigationEnd || event instanceof NavigationSkipped),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe(() => {
                this.checkAndHandleRoute()
            })
    }

    private checkAndHandleRoute() {
        const currentUrl = this.router.url
        const isCreateRoute = currentUrl.includes("/create")

        if (isCreateRoute && this.taskTypesTable) {
            // Open the create dialog
            this.taskTypesTable.openCreateDialog()
        }
    }
}
